module.exports = __webpack_public_path__ + "img/71.c25d07a3.jpg";